// extracted by mini-css-extract-plugin
module.exports = {"root":"RightColumn_root__oqHoW","content":"RightColumn_content__GDJCr","footer":"RightColumn_footer__KcHtW","footerContent":"RightColumn_footerContent__9O_eI"};